import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { useClassName } from '../../../../../../hooks';
import { Typography } from '../../../../../Typography/Typography';
import { RemoveButton } from './components';
import { useIsSelected, useOnMouseDown } from './hooks';
import { useOnMouseEnter } from './hooks/useOnMouseEnter';
import './Option.scss';
import { useScrollToView } from './hooks/useScrollToView';
export const Option = ({ option, removable, onSelect, onDelete, setValue, selectedValues, currentIndex, index, setCurrentIndex, mode, setOptionsAreOpen, setFocused, }) => {
    const ref = useRef(null);
    const [isRemoveButtonHovered, setIsRemoveButtonHovered] = useState(false);
    const isSelected = useIsSelected({ value: option.value, selectedValues });
    const onMouseDown = useOnMouseDown({ setFocused, setValue, setOptionsAreOpen, mode, option, onSelect, isSelected });
    const isCurrent = useMemo(() => index === currentIndex, [index, currentIndex]);
    const textColor = useMemo(() => (isSelected ? 'neutral-300' : 'neutral-700'), [isSelected]);
    const className = useClassName({
        name: 'auto-complete-option',
        prefixed: true,
    }, isSelected ? 'cursor-default' : 'cursor-pointer', isSelected && 'selected', isRemoveButtonHovered && 'remove-button-hovered', isCurrent && 'current');
    const onMouseEnter = useOnMouseEnter({ setCurrentIndex, index });
    useScrollToView({ ref, isCurrent });
    return (_jsxs("div", { ref: ref, "data-testid": `auto-complete-option-${option.value}`, onMouseEnter: onMouseEnter, onMouseDown: onMouseDown, className: className, children: [_jsx(Typography.Text, { color: textColor, size: 'sm', weight: 'semi-bold', children: option.label }), _jsx(RemoveButton, { hovered: isRemoveButtonHovered, setHovered: setIsRemoveButtonHovered, setValue: setValue, onDelete: onDelete, removable: removable, option: option })] }));
};
